import { AuthGuard } from "@app/common/auth.guard";
import { QualificationComponent } from "./component";

export const QualificationRoute = {
  path: "qualification",
  component: QualificationComponent,
  canActivate: [AuthGuard],
};
